import { AttributeStatus } from 'cadenza/repository/model/attribute-status.gen';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import type { AttributeBundleDefinitionDto } from 'cadenza/workbook/model/attribute-bundle-definition-dto';
import type {
  AttributeBundleValidationResult,
  IAttributeBundleValidator,
} from 'cadenza/workbook/workbook-panel/settings/attributes/attribute-bundle-validator';

// See java AttributeBundleValidator.validateAttributeGrouping
export class CustomAggregationAttributeBundleValidator implements IAttributeBundleValidator {
  validate(
    bundleDefinition: AttributeBundleDefinitionDto,
    attribute: WorkbookAttributeDto,
  ): AttributeBundleValidationResult | undefined {
    if (!bundleDefinition.allowCustomAggregationFunctionAttributes && attribute.customAggregationFunctionAttribute) {
      return {
        accepts: false,
        message: AttributeStatus.i18n('CUSTOM_AGGREGATION_FUNCTION_ATTRIBUTE_NOT_ALLOWED'),
      };
    }
  }
}
